import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'

/**
 * Types pinned here: `unwrapCollection` has no inference site in plain JS, so it widens to
 * `unknown[]` and the TypeScript consumers would need a cast on their side.
 *
 * @param {{ farmId: string, year?: string | number, signal?: AbortSignal }} args
 * @returns {Promise<import('../../types/apiModels').FarmSubdivision[]>}
 */
export default async function getFarmSubdivisions({ farmId, year, signal }) {
  const response = await apiClient.get(endpoints.farmSubdivisions, {
    params: { farmId, year },
    signal,
  })
  return unwrapCollection(response)
}
